import {z} from 'zod';

import i18n from '@dms/i18n';

// Product decision: the audit definition form has almost no validation — anything goes.
// Definitions are snapshotted when an audit is created, so editing never affects
// running audits. Weight 1–5 is guaranteed by the dot control, not the schema.
// The only exception is successThreshold (T20-131619): without it the audit result
// cannot be evaluated as passed/failed, so it is mandatory (BE requires it too).
// String fields are trimmed on parse (not a validation — a transform) so padded
// names/descriptions are never persisted, matching other settings form schemas.
export const recordAuditDefinitionFormSchema = z.object({
  name: z.string().trim(),
  resourceIds: z.array(z.string()),
  description: z.string().trim().nullish(),
  category: z.string().trim().nullish(),
  successThreshold: z
    .number({
      required_error: i18n.t('general.validations.fieldIsRequired'),
      invalid_type_error: i18n.t('general.validations.fieldIsRequired'),
    })
    .int(),
  sections: z.array(
    z.object({
      id: z.string(),
      name: z.string().trim(),
    })
  ),
  tasks: z.array(
    z.object({
      description: z.string().trim(),
      isMandatory: z.boolean(),
      fileRequired: z.boolean(),
      weight: z.number().int(),
      sectionId: z.string().nullable(),
      id: z.string().nullish(),
    })
  ),
});

export type RecordAuditDefinitionFormValue = z.infer<typeof recordAuditDefinitionFormSchema>;

export type RecordAuditDefinitionTask = RecordAuditDefinitionFormValue['tasks'][number];

export type RecordAuditDefinitionSection = RecordAuditDefinitionFormValue['sections'][number];
